import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiPromoCategory from "../../../core/api/api.promocategory";
import SwalMessage from "../_Components/SwalMessage";
import SelectComponent from "../_Components/ReactSelectComponent";

export const CopyDiscountGroupModal = ({ showCopyDiscountGroupModal, setShowCopyDiscountGroupModal }) => {
  const [promoCategoryList, setPromoCategoryList] = useState([]);
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm();

  useEffect(() => {
    (async () => {
      try {
        const PromoCategoryList = await ApiPromoCategory.getAllPromoCategory();
        setPromoCategoryList(PromoCategoryList);
      } catch (error) {
      }
    })();
  }, [])

  const handleClose = () => {
    setShowCopyDiscountGroupModal(false);
  };

  const onSubmit = async (data) => {
    try {
      data.sourcePromoCategoryId = data?.sourcePromoCategoryId?.value;
      data.desPromoCategoryIds = data?.desPromoCategoryIds?.map((item) => item?.value);
      let response = await ApiPromoCategory.copyPromoCategory(data);

      if (response.succeeded) {
        handleClose();
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      <Modal centered size="md" show={showCopyDiscountGroupModal} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>کپی آیتم های گروه تخفیف </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Controller
                name="sourcePromoCategoryId"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <SelectComponent
                    placeholder="گروه تخفیف منبع"
                    className="mt-0"
                    options={promoCategoryList?.map((item) => ({
                      value: item.id,
                      label: item.id + "-" + item.name,
                    }))}
                    field={field}
                  />
                )}
              />
              {errors.sourcePromoCategoryId && (
                <div className="text-danger mt-2"> ** گروه تخفیف منبع خود را انتخاب کنید</div>
              )}
            </Col>
            <Col xs="12">
              <Controller
                name="desPromoCategoryIds"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <SelectComponent
                    className="mt-4"
                    placeholder="گروه تخفیف مقصد"
                    options={promoCategoryList?.map((item) => ({
                      value: item.id,
                      label: item.id + "-" + item.name,
                    }))}
                    field={field}
                    isMulti
                  />
                )}
              />
              {errors.desPromoCategoryIds && (
                <div className="text-danger mt-2">** گروه یا گروه های تخفیف مقصد خود را انتخاب کنید</div>
              )}
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
